// Helper to generate a unique key for action objects
export const getActionKey = (action, idx) => {
  // Try to use action.id if present, else fallback to type+idx
  return action && action.id ? `action-${action.id}` : `action-${action.type}-${idx}`;
};

// Helper to generate a unique key for reply actions
export const getActionTypeKey = (action, idx) => {
  return action && action.id ? `action-${action.type}-${action.id}` : `action-${action.type}-${idx}`;
};

// Helper to generate a unique key for meta fields
export const getMetaKey = (meta, metaIndex, action, actionIndex) => {
  // Try to use action.id if present, else fallback to meta+metaIndex+actionIndex
  return action && action.id
    ? `meta-${meta}-${action.id}`
    : `meta-${meta}-${actionIndex}-${metaIndex}`;
};

// Helper to generate a unique key for reply content meta fields
export const getReplyContentMetaKey = (meta, metaIndex, action, actionIndex) => {
  return action && action.id
    ? `meta-content-${meta}-${action.id}`
    : `meta-content-${meta}-${actionIndex}-${metaIndex}`;
};